export default function (context, val) {
    context.state.page = val;
}